export BaseService from "./base.service";
export UserService from "./user.service";
export CompanyService from "./company.service";
export PaymentService from "./payment.service";
export ProductService from "./product.service";
export SefazAcronymsService from "./sefaz-acronyms.service";
export SatService from "./sat.service";
export CustomerService from "./customer.service";
export AccountService from "./account.service";
export AccountingZipService from "./accounting-zip.service";
export SaleService from "./sale.service";
export CategoryService from "./category.service";
export BarcodeService from "./barcode.service";
export StockOperationsService from "./stock-operations.service";
export CashRegisterService from "./cash-register.service";
export PlanService from "./plan.service";
export PaymentInfoService from "./payment-info.service";
export DeviceService from "./device.service";
export ErrorBoundariesService from "./error-boundaries.service";
export OptionalGroupService from "./optional-group.service";
export InvoicesBillingService from "./invoices-billing.service";
export InvoiceAccountantAreaService from "./invoice-accountant-area.service";
export DiscountService from "./discount.service";
export VariationService from "./variation.service";



// WEBPACK FOOTER //
// ./src/core/service/index.js